<template>
<div class="container-fluid">

	<form-toolbar></form-toolbar>

	<div class="d-flex justify-content-between align-items-center pt-3 mb-2">

		<h2 class="mt-3 mr-4">

			<template v-if="!categorySelected">
				Form Template Categories
			</template>

			<template v-else-if="!templateSelected">
				'{{categorySelected.name}}' Templates
			</template>

			<template v-else>
				'{{templateSelected.title}}' Child Templates
			</template>

		</h2>

		<div class="d-flex align-items-center">

			<div class="mr-3">

				<button v-if="!categorySelected" class="btn btn-primary" v-on:click="addCategory">
					<i class="fa fa-plus"></i>
					New Category
				</button>
				<button v-else-if="!templateSelected" class="btn btn-primary" v-on:click="addTemplate">
					<i class="fa fa-plus"></i>
					New Template
				</button>
				<button v-else class="btn btn-primary" v-on:click="addChildTemplate">
					<i class="fa fa-plus"></i>
					New Child Template
				</button>

			</div>

			<context-menu
				v-if="categorySelected"
				:menu-items="menuItems"
				v-on:itemClick="contextMenuClicked">
			</context-menu>
		</div>

	</div>

	<form-child-template-selector
		:category-selected="categorySelected"
		:template-selected="templateSelected"
		:category-slug="categorySlug"
		:template-slug="templateSlug"
		:show-create-links='true'
		v-on:categoryChange="categoryChanged"
		v-on:templateChange="templateChanged"
		v-on:childTemplateClick="editChildTemplate"
		v-on:templatesFetched="templatesFetched"
		v-on:childTemplatesFetched="childTemplatesFetched">		
	</form-child-template-selector>

	<modal-dialog :modal-visible="editCategoryModal.visible"
		confirm-button-text="Save"
		:title="editCategoryModal.title"
		v-on:closeModal="editCategoryModal.visible = false"
		v-on:confirm="saveCategory">

		<field label="Category Name"
			col-class="col-md-4"
			v-model="editCategoryModal.payload.name">
		</field>

	</modal-dialog>

	<modal-dialog :modal-visible="deleteConfirmModal.visible"
		:title="'Delete '+deleteConfirmModal.recordName"
		confirm-button-text="Yes, Delete"
		button-class="btn-outline-danger"
		v-on:closeModal="deleteConfirmModal.visible = false"
		v-on:confirm="confirmDelete">

		Are you sure you want to delete this {{deleteConfirmModal.recordName}}?

	</modal-dialog>

</div>
</template>
<script type="text/javascript">

import ContextMenu from "@/layout_fragments/ContextMenu"
import TableList from "@/components/TableList"
import FormChildTemplateSelector from "@/components/company_forms/FormChildTemplateSelector"

import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

import FormToolbar from "@/pages/forms/FormToolbar";

import FormMixins from "@/mixins/FormMixins.js"

export default {
	name: "FormsList",
	components: {
		ContextMenu,
		ModalDialog,
		Field,
		TableList,
		FormChildTemplateSelector,
		FormToolbar
	},
	mixins: [FormMixins],
	data() {
		return {
			categorySelected: null,
			templateSelected: null,
			categorySlug: null,
			templateSlug: null,
			editCategoryModal: {
				visible: false,
				payload: {},
				title: "Add Category",
				working: false
			},
			deleteConfirmModal: {
				visible: false,
				confirmFunction: "",
				recordName: "",
				working: false
			},
			hasTemplates: false,
			hasChildTemplates: false
		}
	},
	computed: {
		menuItems() {
			let items = []

			if (this.templateSelected) {
				items.push({
					icon: 'fa-pencil-alt',
					text: 'Edit Template',
					clickFunction: "editTemplate"
				})

				items.push({
					icon: 'fa-plus',
					text: 'New Child Template',
					clickFunction: "addChildTemplate"
				})

				let disabled = false
				if (this.hasChildTemplates)
					disabled = true

				items.push({
					icon: 'fa-trash',
					text: 'Delete Template',
					itemClass: 'text-danger',
					clickFunction: 'deleteTemplate',
					disabled
				})
			}
			else if (this.categorySelected) {
				items.push({
					icon: 'fa-pencil-alt',
					text: 'Edit Category',
					clickFunction: 'editCategory'
				})

				items.push({
					icon: 'fa-plus',
					text: 'New Template',
					clickFunction: "addTemplate"
				})

				let disabled = false
				if (this.hasTemplates)
					disabled = true

				items.push({
					icon: 'fa-trash',
					text: 'Delete Category',
					clickFunction: 'deleteCategory',
					itemClass: 'text-danger',
					disabled
				})
			}
			else {
				items.push({
					icon: 'fa-plus',
					text: "New Category",
					clickFunction: "addCategory"
				})
			}

			return items
		}
	},
	methods: {
		contextMenuClicked(clickFunction,item) {
			this[clickFunction]()
		},
		categoryChanged(cat) {
			this.categorySelected = cat
			if (cat)
				window.history.pushState({},"","/forms/templates/"+cat.name.slugify())
			else {
				this.templateSelected = false
				window.history.pushState({},"","/forms/templates")
			}
		},
		templateChanged(temp) {
			this.templateSelected = temp

			if (temp) {
				window.history.pushState({},"","/forms/templates/"+this.categorySelected.name.slugify()+"/"+temp.title.slugify())
			}
			else
				window.history.pushState({},"","/forms/templates/"+this.categorySelected.name.slugify())
		},
		addCategory() {
			this.editCategoryModal.visible = true
			this.editCategoryModal.payload = {
				name: ""
			}
			this.editCategoryModal.title = "Add Category"
		},
		editCategory() {
			this.editCategoryModal.visible = true
			this.editCategoryModal.title = "Edit Category"
			this.editCategoryModal.payload = {
				name: this.categorySelected.name,
				id: this.categorySelected.id
			}
		},
		deleteCategory() {
			this.deleteConfirmModal.visible = true
			this.deleteConfirmModal.recordName = "Category"
			this.deleteConfirmModal.confirmFunction = "confirmDeleteCategory"
		},
		addTemplate() {
			this.$router.push("/forms/template-editor/"+this.categorySelected.name.slugify()+"/new")
		},
		editTemplate() {
			this.$router.push("/forms/template-editor/"+this.categorySelected.name.slugify()+"/"+this.templateSelected.slug)
		},
		deleteTemplate() {
			this.deleteConfirmModal.visible = true
			this.deleteConfirmModal.recordName = "Template"
			this.deleteConfirmModal.confirmFunction = "confirmDeleteTemplate"
		},
		confirmDeleteTemplate() {
			let vm = this

			this.deleteConfirmModal.working = true

			this.postData("FormTemplate/delete",{id: this.templateSelected.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Template deleted")
					vm.deleteConfirmModal.visible = false
					vm.templateSelected = false
					vm.templateChanged(false)
				}
				vm.deleteConfirmModal.working = false
			})
		},
		addChildTemplate() {

			this.$router.push("/forms/child-template-editor/"+this.templateSelected.title.slugify()+"/new")
		},
		editChildTemplate(template) {
			this.$router.push("/forms/child-template-editor/"+this.templateSelected.title.slugify()+"/"+template.slug)
		},
		templatesFetched(templates) {
			if (templates && templates.length > 0)
				this.hasTemplates = true

			else
				this.hasTemplates = false
		},
		childTemplatesFetched(childTemplates) {
			if (childTemplates && childTemplates.length > 0)
				this.hasChildTemplates = true

			else
				this.hasChildTemplates = false
		},
		saveCategory() {
			let vm = this

			this.editCategoryModal.working = true

			let payload = this.cloneObj(this.editCategoryModal.payload)

			this.postData("FormTemplateCategory/save",payload,true).then(response => {
				vm.editCategoryModal.working = false

				if (response.success) {
					vm.alertSaved("Category saved")
					vm.editCategoryModal.visible = false
					vm.fetchTemplateCategories(true)
				}
			})
		},
		confirmDelete() {
			this[this.deleteConfirmModal.confirmFunction]()
		},
		confirmDeleteCategory() {
			let vm = this

			this.deleteConfirmModal.working = true

			this.postData("FormTemplateCategory/delete",{id: this.categorySelected.id},true).then(response => {
				if (response.success) {
					vm.alertSuccess("Category deleted")
					vm.deleteConfirmModal.visible = false
					vm.categorySelected = false
					vm.fetchTemplateCategories(true)
				}
				vm.deleteConfirmModal.working = false
			})
		}
	},
	created() {
		let vm = this

		if ("cat_slug" in this.$route.params)
			this.categorySlug = this.$route.params.cat_slug

		if ('template_slug' in this.$route.params)
			this.templateSlug = this.$route.params.template_slug
	}
}
</script>